import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import 'tachyons';
import 'semantic-ui-css/semantic.min.css'

import { SnackbarProvider } from 'notistack';


import { BrowserRouter } from 'react-router-dom'

import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <SnackbarProvider maxSnack={3}>
        <App />
      </SnackbarProvider>
    </BrowserRouter> 
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
